import { createAction, props } from '@ngrx/store';
import { MailingAddress, ShopifyError } from '../../models';

export const LoadAddresses = createAction('[Addresses] Load Addresses');
export const LoadAddressesSuccess = createAction('[Addresses] Load Addresses Success', props<{ addresses: any }>());
export const LoadAddressesFail = createAction('[Addresses] Load Addresses Fail', props<{ errors: ShopifyError[] }>());

export const LoadMoreAddresses = createAction('[Addresses] Load More Addresses');

export const AddAddress = createAction('[Addresses] Add Address', props<{ address: any; redirect?: string[] }>());
export const AddAddressSuccess = createAction('[Addresses] Add Address Success', props<{ address: any; redirect?: string[] }>());
export const AddAddressFail = createAction('[Addresses] Add Address Fail', props<{ errors: ShopifyError[] }>());

export const UpdateAddress = createAction('[Addresses] Update Address', props<{ address: any; id: string }>());
export const UpdateAddressSuccess = createAction('[Addresses] Update Address Success', props<{ address: any; id: string }>());
export const UpdateAddressFail = createAction('[Addresses] Update Address Fail', props<{ errors: ShopifyError[] }>());

export const DeleteAddress = createAction('[Addresses] Delete Address', props<{ id: string; redirect?: string[] }>());
export const DeleteAddressSuccess = createAction('[Addresses] Delete Address Success', props<{ id: string; redirect?: string[] }>());
export const DeleteAddressFail = createAction('[Addresses] Delete Address Fail', props<{ errors: ShopifyError[] }>());

export const ResetAddressLoadingStates = createAction('[Addresses] Reset Address loading states');
export const ResetAddresses = createAction('[Addresses] Reset Address state');
